
export default {
  name: "QuickLinks",

  props: { slice: { type: Object, required: true } },
};
